import { objectOf } from "@altostra/type-validations";

export const isEngagementQueryBuilderReportIdAppGroupIdExportResult = objectOf({});
